import {
    Component,
    HostListener,
    Input,
    OnChanges,
    SimpleChanges,
    AfterContentChecked
} from '@angular/core';
import {
    ISectorAir,
} from "libraries/service/resources/booking/interfaces/IGetBookings";
import { IRuleTable, ITarificationPricesTable, PricesTableService } from "../../services/prices-table.service";
import {
    ECostOrRetail,
    ERuleLineType,
    ETarificationColumnType,
    ETarificationLineType
} from "../../booking-price-card.enum";
import { BookingType, PriceInBookingType } from "@afidium/ts-facade";
import { Yii } from "../../../../../../interfaces/Yii";
import {
    TravellerPrimitiveXType
} from "libraries/service/resources/booking/interfaces/get-bookings.enum";
import { TravellerType } from "@afidium/ts-facade/model/travellerType";
import { SavingType } from "@afidium/ts-facade/model/savingType";
import { DifferenceType } from "@afidium/ts-facade/model/differenceType";
import {PriceDetailInBookingType} from "@afidium/ts-facade/model/priceDetailInBookingType";

export class Wording {
    public noPrice: string = Yii.t('wui-shared-js', 'Aucune information de tarification à afficher');
    public totalPrice: string = Yii.t('wui-shared-js', 'Total');
    public basePrice: string = Yii.t('wui-shared-js', 'Base');
    public taxPrice: string = Yii.t('wui-shared-js', 'Taxe');
    public surchargePrice: string = Yii.t('wui-shared-js', 'Taxe YQ/YR');
    public segment: string = Yii.t('wui-shared-js', 'Segment');
    public infant: string = Yii.t('wui-shared-js', 'Bébé');
    public child: string = Yii.t('wui-shared-js', 'Enfant');
    public adult: string = Yii.t('wui-shared-js', 'Adulte');
    public rules: string = Yii.t('wui-shared-js', 'Conditions tarifaires');
    public price: string = Yii.t('wui-shared-js', 'Prix');
}

@Component({
    selector: 'tarification-details-table',
    template: `
        <!-- prices table detail-->
        <div class="table-container" *ngIf="dataSource">
            <div class="table-title bold" [class.price-table-header]="isOriginOptimisation">{{wording.price}}</div>
            <table mat-table [id]="'priceTable' + suffix"
                   [dataSource]="dataSource" [class.price-table-margin]="isOriginOptimisation">
                <ng-container *ngFor="let column of displayedColumns; let first = first; let index = index;">
                    <div [matColumnDef]="column" [sticky]="first">
                        <th mat-header-cell *matHeaderCellDef
                            [class.first-column]="first" [ngSwitch]="column" [id]="'priceHeader' + index + suffix">
                            <ng-container *ngSwitchCase="eTarificationColumnType.lineType"></ng-container>
                            <ng-container *ngSwitchCase="eTarificationColumnType.totalOrBaseOrTaxValue"><span
                                    class="bold">{{wording.totalPrice}}</span>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                <span *ngIf="isOriginOptimisation"
                                      class="bold priceHeader{{column | computeTravellerType : null : travellers}}"
                                      (mouseenter)="onMouseEnter(column)"
                                      (mousemove)="onMouseMove($event)"
                                      (mouseleave)="onMouseLeave()">
                                    {{ null | computeTravellerTitle : null : travellers : true : column }}
                                    <mat-card *ngIf="hoveredTravellerSignature === column" class="hovered-card">
                                        <span class="bold">{{ getTravellerByType(column) }}</span>
                                    </mat-card>
                                </span>

                                <span *ngIf="!isOriginOptimisation"
                                      class="bold priceHeader{{column | computeTravellerType : null : travellers}}"
                                      (mouseenter)="onMouseEnter(column)"
                                      (mousemove)="onMouseMove($event)"
                                      (mouseleave)="onMouseLeave()"
                                >
                                    {{column | computeTravellerTitle : null : travellers}}
                                    <mat-card *ngIf="hoveredTravellerSignature === column" class="hovered-card">
                                        <span class="bold">{{ showHoveredTravellerName(column) }}</span>
                                    </mat-card>
                                </span>
                            </ng-container>
                        </th>
                        <td mat-cell
                            *matCellDef="let element; let i = index;">
                            <ng-container *ngIf="first; else notFirst" [ngSwitch]="element[column]">
                                <ng-container
                                        *ngSwitchCase="eTarificationLineType.base">{{wording.basePrice}}</ng-container>
                                <ng-container
                                        *ngSwitchCase="eTarificationLineType.tax">{{wording.taxPrice}}</ng-container>
                                <ng-container
                                        *ngSwitchCase="eTarificationLineType.surcharge">{{wording.surchargePrice}}</ng-container>
                                <ng-container *ngSwitchDefault>{{wording.totalPrice}}</ng-container>
                            </ng-container>
                            <ng-template #notFirst>
                                <ng-container
                                        *ngIf="column === eTarificationColumnType.totalOrBaseOrTaxValue; else notTotal">
                                    <div class="bold price-content"
                                         [innerHTML]="element[column]['rate']?.amount  | priceRealAmount : element[column]['rate']?.currencyCode"></div>
                                    <div *ngIf="element[column]['optimisation']?.amount"
                                         class="bold optimisation price-content"
                                         [innerHTML]="element[column]['optimisation']?.amount | priceRealAmount : element[column]['optimisation']?.currencyCode"></div>
                                    <span *ngIf="!element[column]['optimisation']?.amount"><br></span>
                                </ng-container>
                                <ng-template #notTotal>
                                    <div class="price-content"
                                         [innerHTML]="element[column]['rate']?.unitAmount | priceRealAmount : element[column]['rate']?.currencyCode"></div>
                                    <div class="price-content optimisation"
                                         *ngIf="element[column]['optimisation']?.amount"
                                         [innerHTML]="element[column]['optimisation']?.amount | priceRealAmount : element[column]['optimisation']?.currencyCode"></div>
                                    <span *ngIf="!element[column]['optimisation']?.amount"><br></span>
                                </ng-template>
                            </ng-template>
                        </td>
                    </div>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
        <!-- tarifications table detail-->
        <div class="table-container"
             [ngClass]="isOriginOptimisation && !differences?.length ? 'table-container-relative' : ''"
             *ngIf="price[costOrRetail]?.detailArray?.length && (price[costOrRetail]?.detailArray[0]?.rate?.ruleArray || price[costOrRetail]?.detailArray[0]?.rate?.fareComponentArray)">
            <div class="table-title bold"
                 [class.rule-table-header-right]="isOriginOptimisation && differences?.length" 
                 [class.rule-table-header-left]="isOriginOptimisation && !differences?.length"
            >{{wording.rules}}</div>
            <table mat-table
                   [dataSource]="rulesDataSource"
                   [ngClass]="isOriginOptimisation && !differences?.length ? 'table-margin' : ''">
                <ng-container *ngFor="let column of displayedRuleColumns; let first = first; let index = index;">
                    <div [matColumnDef]="column" [sticky]="first">
                        <th mat-header-cell *matHeaderCellDef
                            [class.first-column]="first" [ngSwitch]="column" [width]="ruleHeaderSize[index]">
                            <span class="bold" *ngSwitchCase="eRuleLineType.sectorLine">{{wording.segment}}</span>
                            <ng-container class="bold" *ngSwitchDefault>
                                <span
                                        class="bold priceHeader{{column | computeTravellerType : null : travellers}}"
                                        (mouseenter)="onMouseEnterPrice(column)"
                                        (mousemove)="onMouseMovePrice($event)"
                                        (mouseleave)="onMouseLeavePrice()">
                                    {{ null | computeTravellerTitle : null : travellers : true : column }}
                                    <mat-card *ngIf="hoveredTravellerSignaturePrice === column" class="hovered-card">
                                        <span class="bold">{{ getTravellerByType(column) }}</span>
                                    </mat-card>
                                </span>
                            </ng-container>
                        </th>
                        <td mat-cell
                            *matCellDef="let element; let i = index;">
                            <ng-container *ngIf="first; else notFirst">
                                <sector-detail [price]="price"
                                               [booking]="booking"
                                               [costOrRetail]="costOrRetail"
                                               [showMoreDetails]="false"
                                               [differences]="differences"
                                               [sectorSignature]="element[eRuleLineType.sectorLine]"
                                               [isOriginOptimisation]="isOriginOptimisation"
                                ></sector-detail>
                            </ng-container>
                            <ng-template #notFirst>
                                <sector-detail [price]="price"
                                               [booking]="booking"
                                               [costOrRetail]="costOrRetail"
                                               [showMoreDetails]="false"
                                               [showDifferencesOnly]="true"
                                               [differences]="differences"
                                               [typoPax]="column"
                                               [sectorSignature]="element[eRuleLineType.sectorLine]"
                                               [isOriginOptimisation]="isOriginOptimisation"></sector-detail>
                            </ng-template>
                        </td>
                    </div>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedRuleColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedRuleColumns;"></tr>
            </table>
        </div>
        <div *ngIf="!price" class="noInformation">{{ wording.noPrice }}</div> 
    `,
    styleUrls: ['./tarification-details-table.scss'],
})
export class TarificationDetailsTableComponent implements AfterContentChecked, OnChanges {

    @Input()
    public price: PriceInBookingType;

    @Input()
    public suffix: string;

    @Input()
    public booking: BookingType;

    @Input()
    public costOrRetail: string = ECostOrRetail.cost;

    @Input()
    public isOriginOptimisation: boolean = false;

    @Input()
    public saving?: SavingType;

    @Input()
    public differences?: DifferenceType[];

    public travellers: TravellerType[] = [];

    public sectors: ISectorAir[];
    public wording: Wording = new Wording();
    public dataSource: ITarificationPricesTable[];
    public rulesDataSource: IRuleTable[];
    public displayedColumns: string[] = [];
    public displayedRuleColumns: string[] = [];
    public eTarificationColumnType: typeof ETarificationColumnType = ETarificationColumnType;
    public eTarificationLineType: typeof ETarificationLineType = ETarificationLineType;
    public travellerPrimitiveXType: typeof TravellerPrimitiveXType = TravellerPrimitiveXType;
    public eRuleLineType: typeof ERuleLineType = ERuleLineType;
    public ruleHeaderSize: number[] = [];
    public mouseX: number;
    public mouseY: number;
    public hoveredTravellerSignature: string | null = null;
    public hoveredTravellerSignaturePrice: string | null = null;

    public constructor(
        private readonly pricesTablesService: PricesTableService
    ) {
    }

    @HostListener('window:resize', ['$event'])
    public onResize(): void {
        this.handleColumnSize();
    }

    public ngAfterContentChecked(): void {
        this.handleColumnSize();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes && this.price && this.booking) {
            const travellersInPrice: TravellerType[] = [];
            this.price[this.costOrRetail].detailArray.forEach((detail: PriceDetailInBookingType): void => {
                travellersInPrice.push(...detail.travellerArray);
            });
            for(const travellerInPrice of travellersInPrice){
                this.travellers.push(this.booking?.travellerArray.find((traveller: TravellerType) => traveller.signature === travellerInPrice.signature));
            }

            this.displayedColumns = [];
            this.dataSource = this.pricesTablesService.constructPriceDetailData(this.price, this.travellers, this.costOrRetail, this.isOriginOptimisation, this.saving);
            Object.keys(this.dataSource[0]).forEach((key: string): void => {
                this.displayedColumns.push(key);
            });
            const totalIndex: number = this.dataSource.findIndex(item => item.lineType === "total");
            if (totalIndex !== -1) {
                const totalItem: ITarificationPricesTable = this.dataSource.splice(totalIndex, 1)[0];
                this.dataSource.push(totalItem);
            }
            this.displayedRuleColumns = [];
            this.rulesDataSource = this.pricesTablesService.constructRulesDetailData(this.price, this.travellers, this.costOrRetail, this.booking);
            Object.keys(this.rulesDataSource[0]).forEach((key: string): void => {
                this.displayedRuleColumns.push(key);
            });
        }
    }

    public getTravellerByType(type: string): string {
        const initialTravellersArray: string[] = this.travellers.filter((travellerItem: TravellerType): boolean => travellerItem.xType === type)
            .map((travellerItem: TravellerType): string => {
                return `${travellerItem.firstName ?? ''} ${travellerItem.lastName ?? ''}`;
            });
        return initialTravellersArray.join(" - ");

    }

    public onMouseEnterPrice(column: string): void {
        this.hoveredTravellerSignaturePrice = column;
    }

    public onMouseMovePrice(event: MouseEvent): void {
        this.mouseX = event.clientX;
        this.mouseY = event.clientY;
    }

    public onMouseLeavePrice(): void {
        this.hoveredTravellerSignaturePrice = null;
    }


    public showHoveredTravellerName(signature: string): string | null {
        const travellersToFormat: TravellerType[] = this.booking ? this.booking?.travellerArray : null;
        const traveller: TravellerType = travellersToFormat?.find((travellerItem: TravellerType): boolean => {
            return travellerItem?.signature === signature;
        });
        if (traveller) {
            return `${traveller.firstName ?? ''} ${traveller.lastName ?? ''}`;
        }
        return null;
    }


    public onMouseEnter(column: string): void {
        this.hoveredTravellerSignature = column;
    }


    public onMouseMove(event: MouseEvent): void {
        this.mouseX = event.clientX;
        this.mouseY = event.clientY;
    }

    public onMouseLeave(): void {
        this.hoveredTravellerSignature = null;
    }


    private handleColumnSize(): void {
        const suffix: string = this.suffix;
        this.ruleHeaderSize[0] = (document.getElementById(`priceHeader0${suffix}`)?.offsetWidth ?? 0) + document.getElementById(`priceHeader1${suffix}`)?.offsetWidth ?? 0;
        const tableWidth: number = (document.getElementById(`priceTable${suffix}`)?.offsetWidth ?? 0) - this.ruleHeaderSize[0];

        this.ruleHeaderSize[1] = this.ruleHeaderSize[2] = this.ruleHeaderSize[3] = Math.round(tableWidth / (this.displayedRuleColumns.length - 1));

    }
}
